export default "__VITE_PUBLIC_ASSET__edd06e7a__"